export const TYPE = ["password", "text"];